(function(){
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const T=(window.FH&&FH.t)||{};
  function toast(msg){const t=$('#toast');if(!t)return;t.textContent=msg;t.classList.add('show');clearTimeout(t._h);t._h=setTimeout(()=>t.classList.remove('show'),2200);}
  function money(cents){
    const fmt=(FH.moneyFormat||'CHF {{amount}}');
    const a=(cents/100).toFixed(2);
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,a.replace('.',','))
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(cents/100))
              .replace(/\{\{\s*amount\s*\}\}/,a).replace(/<[^>]+>/g,'');
  }
  async function refreshCount(){try{const c=await (await fetch((FH.cartUrl||'/cart')+'.js')).json();const el=$('#cartCount');if(el){el.textContent=c.item_count;el.classList.remove('bump');void el.offsetWidth;el.classList.add('bump');}}catch(e){}}

  const mm=$('#mobileMenu');
  
  

  document.addEventListener('click',e=>{
    const chip=e.target.closest('.size-chip[data-variant]');
    if(chip){const card=chip.closest('.card');$$('.size-chip',card).forEach(c=>c.classList.toggle('active',c===chip));
      $('input[name="id"]',card).value=chip.dataset.variant;$('.card-price',card).innerHTML=chip.dataset.price;return;}
    const pv=e.target.closest('[data-pd-variant]');
    if(pv){$$('[data-pd-variant]').forEach(c=>c.classList.toggle('active',c===pv));$('#pdVariant').value=pv.dataset.pdVariant;$('#pdPrice').innerHTML=pv.dataset.price;
      const u=new URL(location.href);u.searchParams.set('variant',pv.dataset.pdVariant);history.replaceState(null,'',u);return;}
    const tab=e.target.closest('[data-reco-tab]');
    if(tab){const sec=tab.closest('[data-reco-section]');const open=tab.getAttribute('aria-selected')==='true';
      $$('[data-reco-tab]',sec).forEach(b=>b.setAttribute('aria-selected',!open&&b===tab));
      $$('[data-reco-panel]',sec).forEach(p=>{p.hidden=open||p.dataset.recoPanel!==tab.dataset.recoTab;if(!p.hidden){p.classList.remove('reco-in');void p.offsetWidth;p.classList.add('reco-in');}});return;}
    const st=e.target.closest('[data-step]');
    if(st){const inp=st.parentElement.querySelector('input');inp.value=Math.max(0,Number(inp.value)+Number(st.dataset.step));const f=$('#cartForm');if(f){const u=f.querySelector('[name="update"]');if(f.requestSubmit&&u)f.requestSubmit(u);else f.submit();}return;}
  });

  const q=$('#pdQty');
  if(q){$('#qtyMinus').addEventListener('click',()=>q.value=Math.max(1,Number(q.value)-1));$('#qtyPlus').addEventListener('click',()=>q.value=Math.min(20,Number(q.value)+1));}

  async function ajaxAdd(form){
    const btn=form.querySelector('[type="submit"]');if(btn)btn.disabled=true;
    try{const r=await fetch((FH.cartAddUrl||'/cart/add')+'.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
      if(!r.ok) throw 0; await refreshCount(); toast(T.added||'✓');}
    catch(e){form.submit();}
    finally{if(btn)btn.disabled=false;}
  }
  $$('form[data-ajax-add], #pdForm').forEach(f=>f.addEventListener('submit',e=>{e.preventDefault();ajaxAdd(f);}));

  const sort=$('#sortSelect');
  if(sort) sort.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',sort.value);location.href=u;});
  const ff=$('#filterForm');
  if(ff) ff.addEventListener('change',()=>{const p=new URLSearchParams(new FormData(ff));location.search=p.toString();});
  const ft=$('#filterToggleBtn');
  if(ft) ft.addEventListener('click',()=>$('#filterPanel').classList.toggle('open'));

  const ov=$('#searchOverlay'), inp=$('#soInput'), box=$('#soResults');
  const initial=box?box.innerHTML:'';
  function openS(){ov.classList.add('open');ov.setAttribute('aria-hidden','false');mm&&mm.classList.remove('open');setTimeout(()=>inp.focus(),60);}
  function closeS(){ov.classList.remove('open');ov.setAttribute('aria-hidden','true');}
  const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  async function run(){
    const v=inp.value.trim();
    if(!v){box.innerHTML=initial;return;}
    try{
      const url=(FH.predictiveUrl||'/search/suggest')+'.json?q='+encodeURIComponent(v)+'&resources[type]=product,article&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      const d=await (await fetch(url)).json();
      const res=(d.resources&&d.resources.results)||{};
      const ps=res.products||[], as=res.articles||[];
      if(!ps.length&&!as.length){box.innerHTML=`<p class="so-empty">${esc(T.none||'')}</p>`+initial;return;}
      let h='';
      if(ps.length){h+=`<div class="so-h">${esc(T.results||'')} (${ps.length})</div><div class="so-list">`+ps.map(p=>{
        const img=(p.featured_image&&p.featured_image.url)||p.image||'';
        const price=p.price_min!==undefined?p.price_min:p.price;
        const pr=price===undefined?'':(String(price).includes('.')?money(Math.round(parseFloat(price)*100)):money(Number(price)));
        return `<a class="so-item" href="${p.url}"><span class="so-thumb">${img?`<img src="${img}${img.includes('?')?'&':'?'}width=160" alt="" loading="lazy">`:''}</span><span><span class="so-brand">${esc(p.vendor||'')}</span><br><span class="so-name">${esc(p.title)}</span></span><span class="so-price">${esc(T.from||'')} ${pr}</span></a>`;}).join('')+`</div>`;}
      if(as.length){h+=`<div class="so-h" style="margin-top:20px">${esc(T.articles||'Blog')}</div><div class="so-posts">`+as.map(a=>`<a href="${a.url}">${esc(a.title)}</a>`).join('')+`</div>`;}
      h+=`<a class="so-all" href="${FH.searchUrl||'/search'}?q=${encodeURIComponent(v)}&type=product,article">${esc(T.all||'')}</a>`;
      box.innerHTML=h;
    }catch(e){}
  }
  if(ov){
    
    
    ov.addEventListener('click',e=>{if(e.target===ov)closeS();const c=e.target.closest('[data-sq]');if(c){inp.value=c.dataset.sq;run();inp.focus();}});
    document.addEventListener('keydown',e=>{if(e.key==='Escape')closeS();if(e.key==='/'&&!/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)){e.preventDefault();openS();}});
    let timer;inp.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(run,180);});
  }
})();
